import { useSelectedStudentIdContext } from "#/components/exam-results/context/studentsList/context";
import { useBreakLG } from "@monta/design-system";
import clsx from "clsx";
import { possibleStatus } from "../constants";
import type { DqGlobalProps } from "../types";
import {
  getDifficultyLevel,
  getQuestionStatus,
  useGetQuestions,
} from "../utils";
import styles from "./dqHeader.module.scss";

export const QuestionStatus = (props: DqGlobalProps) => {
  const { id } = props;
  const { selectedStudentId } = useSelectedStudentIdContext();
  const { answerId, difficultyLevelId, selectedChoiceId, questionTypeId } =
    useGetQuestions(selectedStudentId, id)[0];

  const isLG = useBreakLG();

  const currentStatus =
    possibleStatus[getQuestionStatus({ selectedChoiceId, answerId })];

  const level = getDifficultyLevel(difficultyLevelId);

  if (questionTypeId === 20)
    return <div className={styles["status-container"]}></div>;

  return (
    <div
      className={clsx(
        styles["status-container"],
        styles[`status-container__${currentStatus.className}`],
      )}
    >
      <div className={styles["status-container__question-status"]}>
        <img src={currentStatus.icon} alt={currentStatus.title} />
        <span>{currentStatus.title}</span>
      </div>

      {!isLG && <span>{level.label}</span>}
    </div>
  );
};
